export default `
  listingInternalLinking(locale:$locale) {
    title
    links {
      anchorText
        url
    }
  }
`;
